/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func,
    object,
    shape,
    bool,
    string,
} from 'prop-types';
import * as Joi from 'joi-browser';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import { Grid, InputLabel } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../../common/Form';
import configENV from '../../config';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import withValidation from '../../../Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/ValidationHOC';
import TextFieldWrapper from '../../../Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/TextFieldWrapper';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    CustomerWrapperPLA: {
        '&.PLA': {
            padding: '0 15px',
            maxWidth: '1270px',
            margin: '55px auto',
            flexDirection: 'column',

            '& .form-container': {
                width: '40%',

                '& button': {
                    margin: '0 !important',
                    width: '100% !important',
                    float: 'left !important',
                    color: '#212324 !important',
                    border: '1px solid #b9e529 !important',
                    backgroundColor: '#b9e529 !important',
                },

                '& .alert, .success': {
                    marginBottom: '20px',
                },

                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },
            },
        },
    },
    inputWrapper: {
        position: 'relative',
        paddingBottom: '30px',
        '& label': {
            display: 'none',
            '&+ div': {
                margin: 0,
                padding: '8px 0',
                fontSize: '1.14rem !important',
                '& input': {
                    fontSize: '1.14rem !important',
                },
            },
        },
        '& > div p': {
            position: 'absolute',
            width: '100%',
            left: 0,
            bottom: '-26px',
        },
    },
    inputLabel: {
        '& > label': {
            display: 'block',
            color: '#000000',
            fontSize: '1rem !important',
            '& + div': {
                padding: '0',
            },
        },
    },
    inputTitle: {
        margin: 0,
        paddingBottom: '5px',
        fontWeight: 600,
    },
});

class ChangePasswordPLA extends Form {
    constructor(props) {
        super(props);

        this.state = {
            formSubmitted: false,
            data: {
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
        };
    }

    schema = {
        currentPassword: Joi.string()
            .trim()
            .min(6)
            .max(15)
            .required()
            .label('Current Passowrd'),
        newPassword: Joi.string()
            .trim()
            .min(6)
            .max(15)
            .required()
            .label('New Passowrd'),
        confirmPassword: Joi.string()
            .trim()
            .min(6)
            .max(15)
            .required()
            .label('Confirm Passowrd'),
    };

    doSubmit = () => {
        if (!(
            this.props.formFieldState.currentPassword.flagError
            || this.props.formFieldState.newPassword.flagError
            || this.props.formFieldState.confirmPassword.flagError
        )) {
            this.state.formSubmitted = true;
            const { handleUpdatePassword } = this.props;
            const data = { ...this.state.data };

            handleUpdatePassword(data);
        }
    };

    render() {
        const {
            formFieldState,
            isReadyState,
            classes,
            dataDictionary,
            error,
            brand,
            userProfile,
            successMessage,
            history,
        } = this.props;

        if (successMessage && this.state.formSubmitted) {
            this.state.formSubmitted = false;
            this.state.data = {
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
            };
            setTimeout(() => {
                history.push('/auth/logout');
            }, 2000);
        }

        const handleFieldChange = (event) => {
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    [event?.target?.name]: event?.target?.value,
                },
            }));
        };

        const handleFieldBlur = (key, response) => {
            const { handleOnBlur } = this.props;
            handleOnBlur(key, response, this.state.data);
        };

        return (
            <div className={`container PLA ${classes.CustomerWrapperPLA}`}>
                <AccountLeftMenu brand={brand} userProfile={userProfile} />

                <form className="form-container" onSubmit={(event) => this.handleSubmit(event)} disabled={!isReadyState}>
                    <Grid xs={12} sm={12} md={12} lg={12} item className={`${classes.inputWrapper} ${classes.inputLabel}`}>
                        <InputLabel htmlFor="currentPassword" className={classes.inputTitle}>
                            {dataDictionary?.['Current Password'] || 'Current Password'}
                        </InputLabel>
                        <TextFieldWrapper
                            isPlants
                            customInput
                            label="Current Password"
                            name="currentPassword"
                            inputFieldType="password"
                            validateRule="Password"
                            required={formFieldState.currentPassword.required}
                            flagError={formFieldState.currentPassword.flagError}
                            errorMessage={formFieldState.currentPassword.errorMessage}
                            variant="outlined"
                            val={this.state.data.currentPassword}
                            max={15}
                            min={6}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                        />
                    </Grid>

                    <Grid xs={12} sm={12} md={12} lg={12} item className={`${classes.inputWrapper} ${classes.inputLabel}`}>
                        <InputLabel htmlFor="newPassword" className={classes.inputTitle}>
                            {dataDictionary?.['New Password'] || 'New Password'}
                        </InputLabel>
                        <TextFieldWrapper
                            isPlants
                            customInput
                            label="New Password"
                            name="newPassword"
                            inputFieldType="password"
                            validateRule="Password"
                            required={formFieldState.newPassword.required}
                            flagError={formFieldState.newPassword.flagError}
                            errorMessage={formFieldState.newPassword.errorMessage}
                            variant="outlined"
                            val={this.state.data.newPassword}
                            max={15}
                            min={6}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                        />
                    </Grid>

                    <Grid xs={12} sm={12} md={12} lg={12} item className={`${classes.inputWrapper} ${classes.inputLabel}`}>
                        <InputLabel htmlFor="confirmPassword" className={classes.inputTitle}>
                            {dataDictionary?.['Confirm Password'] || 'Confirm Password'}
                        </InputLabel>
                        <TextFieldWrapper
                            isPlants
                            customInput
                            label="Confirm Password"
                            name="confirmPassword"
                            inputFieldType="password"
                            password={this.state.data.newPassword}
                            validateRule="ConfirmPassword"
                            required={formFieldState.confirmPassword.required}
                            flagError={formFieldState.confirmPassword.flagError}
                            errorMessage={formFieldState.confirmPassword.errorMessage}
                            variant="outlined"
                            val={this.state.data.confirmPassword}
                            max={15}
                            min={6}
                            isInputFilled={handleFieldBlur}
                            setTextInputState={handleFieldChange}
                        />
                    </Grid>

                    {error.message && (
                        <div className="alert">
                            <Alert severity="error">
                                {error.message}
                            </Alert>
                        </div>
                    )}

                    {successMessage && (
                        <div className="success">
                            <Alert severity="success">
                                {successMessage}
                            </Alert>
                        </div>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        Save
                    </Button>
                </form>
            </div>
        );
    }
}
ChangePasswordPLA.defaultProps = {
    error: '',
    successMessage: '',
    history: {},
};

ChangePasswordPLA.propTypes = {
    classes: object.isRequired,
    history: object,
    handleUpdatePassword: func.isRequired,
    formFieldState: shape({
        currentPassword: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        newPassword: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        confirmPassword: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
    }).isRequired,
    error: object,
    successMessage: string,
    dataDictionary: object.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] || state;

    return {
        error: newState.error,
        isReadyState: newState.isReadyState,
        successMessage: newState.successMessage,
        dataDictionary: getDataDictionary(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleUpdatePassword: (data) => dispatch(EventDispatcher.handleUpdatePassword(data)),
});

const initState = {
    currentPassword: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    newPassword: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    confirmPassword: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(withValidation(ChangePasswordPLA, initState))));
